module.exports = __webpack_public_path__ + "img/outlander-18.e0aba9d5.png";